module.exports = __webpack_public_path__ + "img/GRAC.7ee960a8.png";